import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ spacing }) => ({
  categoryForm: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  title: {
    fontFamily: Theme.Typography.FontFamily.DMSans,
    fontSize: '22px',
    marginBottom: '15px',
    lineHeight: '112.5%',
    color: Theme.Colors.Grayscale.OneThousand,
  },
  label: {
    fontFamily: Theme.Typography.FontFamily.DMSans,
    fontSize: '12px !important',
    fontWeight: '500',
    lineHeight: '112.5%',
    color: `${Theme.Colors.Grayscale.OneThousand} !important`,
  },
  labelSelect: {
    fontFamily: Theme.Typography.FontFamily.DMSans,
    fontSize: '12px !important',
    fontWeight: '500',
    lineHeight: '112.5%',
    color: `${Theme.Colors.Grayscale.OneThousand} !important`,
    marginTop: '15px',
  },
  textfield: {
    marginRight: '10px',
    marginBottom: '10px',
    width: '100%',
  },
  select: {
    width: '90px',
    textAlign: 'center',
  },
  sectionWrapper: {
    display: 'flex',
    gap: '10px',
    flexDirection: 'row',
  },
  sectionRowWrapper: {
    gap: '10px',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
  },
  fieldWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
  },
  accordion: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(10),
  },
  containerAdd: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(10),
  },
  deleteButton: {
    width: '120px',
    marginTop: spacing(1.25),
    textTransform: 'none',
    textDecoration: 'underline !important',
    backgroundColor: 'transparent !important',
    color: `${Theme.Colors.Red.Base} !important`,
    padding: '0 !important',
    minWidth: 'auto !important',
    boxShadow: 'none !important',
    '&:hover': {
      backgroundColor: 'transparent !important',
      textDecoration: 'underline !important',
      boxShadow: 'none !important',
    },
  },
  tooltipLabel: {
    display: 'flex',
    flexDirection: 'row',
    gap: '0.5rem',
    alignItems: 'center',
  },
  tooltipIcon: {
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '2.4rem',
    fill: Theme.Colors.Grayscale.SixtyFour,
    margin: 0,
  },
  checkboxContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
}))
